    import { initializeApp } from "firebase/app";
    import { getFirestore } from "firebase/firestore";
    import { getAuth } from "firebase/auth";
    import { getFunctions } from "firebase/functions"; // Importa as Funções

    const firebaseConfig = {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID
    };

    // Inicializa a aplicação
    export const app = initializeApp(firebaseConfig);

    // Exporta os serviços que vamos usar
    export const db = getFirestore(app);
    export const auth = getAuth(app);
    export const functions = getFunctions(app); // Inicializa e exporta as Funções
    window.firebaseAuth = auth;
